import { TextField } from "@mui/material";
import type { ChangeEvent, FC } from "react";

interface Props {
  readonly label?: string;
  readonly fullWith?: boolean;
  readonly accept?: string;
  readonly onFileChange: (value: File) => void;
}

const LocalFilePicker: FC<Props> = ({ label, fullWith, accept, onFileChange }) => {
  const handleFilesChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const files = (e.target as HTMLInputElement).files || [];
    // Update chosen files
    onFileChange(files[0]);
  };

  return (
    <TextField
      label={label}
      fullWidth={fullWith}
      type="file"
      onChange={handleFilesChange}
      slotProps={{
        htmlInput: { accept },
        inputLabel: { shrink: true },
      }}
    />
  );
};

export default LocalFilePicker;
